import { createContext } from 'react';
import { TrafficGroup } from '../Utils/types/MaterialPropertiesTypes.ts';
import { KjørefeltType } from '../Utils/types/GrunnlagTypes.ts';

export type SaltingAvVegen = 'Ja' | 'Nei';
export interface IFormInputs {
	fartsgrense?: number;
	andeltunge?: number;
	trafikkvekst?: number;
	ådt?: number;
	kjørefelt?: KjørefeltType;
	name?: string;
	dimPeriod?: number;
	årsMiddelTemperatur?: number;
	fDim?: number;
	saltingAvVegen?: SaltingAvVegen;
	piggdekkDager?: number;
	piggdekkandel?: number;
	weatherStationId?: number;
	dimensjoneringsKlasseNavn?: string;
	truckWandering?: number;
	carWandering?: number;
	truckFactor?: number;
	kulemølleVerdi?: number;
	andelTilslag?: number;
}

export type DimGrunnlagContextTypeValues = {
	trafficGroup?: TrafficGroup;
	trafficGroupNValue?: number;
} & IFormInputs;

type DimGrunnlagContextType = {
	values: DimGrunnlagContextTypeValues;
	updateValues: (values: DimGrunnlagContextTypeValues) => void;
	loading: boolean;
};
/**
 * loading er brukt til å si ifra om values av type {DimGrunnlagContextTypeValues} har blitt lastet inn fra sessionStorage </br>
 * Rett og slett for å unngå at useEffect-en som bruker values trigger hele tiden. </br>
 * @param children
 * @constructor
 */
export const DimGrunnlagContext = createContext<DimGrunnlagContextType>({
	values: {},
	updateValues: () => {},
	loading: true,
});
